import React from 'react'
import "./errorstyles.css"

function Error() {
  return (
    <div className="content">This is an error page</div>
  )
}

export default Error